<div class="main">
  <div class="header" [ngStyle]="{'background-color':(parentData.type==2 || parentData.type==3)? '#631d4f':'#631d4f'}">
    <span>{{parentData.heading}}</span>
    <span *ngIf="parentData.type == 0 || parentData.type == 1" style="margin-left: 3%;border-left: dashed 1px #fff;padding-left: 1%;"> {{'preShipment.total' | translate}}: {{parentData.count}}</span>
    <i class="material-icons" (click)="closeModal();">clear</i>
    <!-- <i *ngIf="parentData.type==1" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'acceptance')">launch</i> -->
   <!--  <i *ngIf="parentData.type==2" class="material-icons dashIcon" (click)="openDashboard($event, 'live', 'assignment')">launch</i> -->
  </div>
  <div class="section">

    <div class="body">

      <div class="cardSection" *ngIf="parentData.type == 0">
        <div class="cards" *ngFor="let item of pendingAcceptance; let i = index;">
          <div class="cardHeader">
            <div class="headerRow">{{'preShipment.order' | translate}}: {{item.OIN}}</div>
            <!-- <div class="headerRow"> Pending Allocation </div> -->
            <div class="headerRow"> {{'preShipment.totalPending' | translate}}: {{item.to_be_accepted || 'N/A'}} </div>
          </div>
          <div class="cardBody diff" *ngFor="let element of item.allocations; let ind = index;">
            <div class="cardRow">
              <span style="font-size: 10px; display: none;">{{ind + 1}}.</span> {{element.shipper.parent_name || 'N/A'}} - {{element.shipper.name || 'N/A'}}
            </div>
            <div class="cardRow">
              {{element.allocated}}
            </div>
            <div class="cardRow">
              <span *ngIf="getDuration(element.acceptance_deadline)">{{'preShipment.expiresIn' | translate}}: {{getDuration(element.acceptance_deadline)}}</span>
              <span *ngIf="!getDuration(element.acceptance_deadline)">{{'preShipment.expired' | translate}}</span>
              <br>
              <span style="font-size: 9px;">{{'preShipment.deadline' | translate}}: {{getDate(element.acceptance_deadline)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cardSection" *ngIf="parentData.type == 1">
        <div class="cards" *ngFor="let item of pendingAssignment; let i = index;">
          <div class="cardHeader">
            <div class="headerRow">{{'preShipment.order' | translate}}: {{item.OIN}} </div>
            <!-- <div class="headerRow"> Pending Allocation </div> -->
            <div class="headerRow"> {{'preShipment.totalPending' | translate}}: {{item.total_accepted - item.total_assigned}} </div>
          </div>
          <div class="cardBody diff" *ngFor="let element of item.allocations; let ind = index;">
            <div class="cardRow">
              <span style="font-size: 10px; display: none;">{{ind + 1}}.</span> {{element.shipper.parent_name}} - {{element.shipper.name}}
            </div>
            <div class="cardRow">
              {{element.accepted - element.assigned}}
            </div>
            <div class="cardRow">
              <span *ngIf="getDuration(element.assignment_deadline)">{{'preShipment.expiresIn' | translate}}: {{getDuration(element.assignment_deadline)}}</span>
              <span *ngIf="!getDuration(element.assignment_deadline)">{{'preShipment.expired' | translate}}</span>
              <br>
              <span style="font-size: 9px;">{{'preShipment.deadline' | translate}}: {{getDate(element.assignment_deadline)}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="cardSection" *ngIf="parentData.type == 2">
        <div class="tableSection">
          <table mat-table *ngIf="consentStatusData.length;else noConsentData" [dataSource]="consentStatusData">
  
            <ng-container matColumnDef='sin'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.shipmentId' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.SIN || 'N/A'}} </td>
            </ng-container>
  
            <ng-container matColumnDef='driver'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.driver' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div> {{ (element.driver && element.driver.name) ?  element.driver.name : 'N/A'}} </div>
                <div> {{ (element.driver && element.driver.mobile) ? countryCode + element.driver.mobile : 'N/A'}} </div>
              </td>
            </ng-container>
  
            <ng-container matColumnDef='assignedTime'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.assignedTime' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.assignedTime || 'N/A'}} </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="consentHeaders; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: consentHeaders"></tr>
          </table>
        </div>

        <ng-template #noConsentData>
          <div class="noConsentData" style="padding-top: 30px; text-align: center; color:#D8511F">
            {{'preShipment.noData' | translate}}
          </div>
        </ng-template>

      </div>

      <div class="cardSection" *ngIf="parentData.type == 3">
        
        <div class="tableSection">
          <table mat-table *ngIf="driverAcceptanceData.length;else noConsentData" [dataSource]="driverAcceptanceData">
  
            <ng-container matColumnDef='sin'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.shipmentId' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.SIN || 'N/A'}} </td>
            </ng-container>
  
            <ng-container matColumnDef='driver'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.driver' | translate}} </th>
              <td mat-cell *matCellDef="let element">
                <div> {{ (element.driver && element.driver.name) ?  element.driver.name : 'N/A'}} </div>
                <div> {{ (element.driver && element.driver.mobile) ? countryCode + element.driver.mobile : 'N/A'}} </div>
              </td>
            </ng-container>
  
            <ng-container matColumnDef='assignedTime'>
              <th mat-header-cell *matHeaderCellDef> {{'preShipment.assignedTime' | translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.assignedTime || 'N/A'}} </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="driverHeaders; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let myRowData; columns: driverHeaders"></tr>
          </table>

        </div>

        <ng-template #noConsentData>
          <div class="noConsentData" style="padding-top: 30px; text-align: center; color:#D8511F">
            {{'preShipment.noData' | translate}}
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>